import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/logo-white.png'


const _hoisted_1 = {
  class: "row",
  role: "tabpanel"
}
const _hoisted_2 = { class: "d-flex flex-row-fluid" }
const _hoisted_3 = { class: "d-flex flex-column flex-row-fluid align-items-center" }
const _hoisted_4 = { class: "d-flex flex-column flex-column-fluid mb-5 mb-lg-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-none d-md-flex flex-center mt-10 mb-8" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: _imports_0,
    class: "h-50px h-lg-80px"
  })
], -1)
const _hoisted_6 = { class: "row g-7 w-xxl-850px" }
const _hoisted_7 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_8 = {
  style: {"font-size":"2.75rem !important"},
  class: "fs-1"
}
const _hoisted_9 = { class: "fs-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fad text-muted fa-info-circle ms-1" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-content border-primary mt-16" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "w-250px fs-3 fw-bolder" }, "Join a Production")
], -1)
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "fs-2" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "fs-2" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fs-2" }, "You're not a member of any productions.", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-content border-info mt-20" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "w-250px fs-4 fw-bolder" }, "Complete Your Profile")
], -1)
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Verify your phone number so you can receive text alerts, add your emergency contact information, and more to get the full benefits of StageHub.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CreateOrganizationModal = _resolveComponent("CreateOrganizationModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, "Welcome, " + _toDisplayString(_ctx.userStore.profile.firstName) + "!", 1),
              _createElementVNode("div", _hoisted_9, [
                _createTextVNode("Your StageCode is "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.userStore.profile.stageCode), 1),
                _createVNode(_component_el_tooltip, {
                  content: "Share this code with stage managers so they can invite you to their production.",
                  placement: "bottom"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              (_ctx.invitations.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createTextVNode("You've been invited to join "),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.invitations[0].entityName), 1),
                      _createTextVNode("!")
                    ]),
                    _createVNode(_component_Button, {
                      class: "mt-4",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewInvitation(_ctx.invitations[0])))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Accept or Decline ")
                      ]),
                      _: 1
                    })
                  ]))
                : (_ctx.requests.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createTextVNode("You've requested to join "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requests, (request) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: request.entityName
                          }, [
                            _createTextVNode(_toDisplayString(request.entityName), 1),
                            false
                              ? (_openBlock(), _createElementBlock("span", _hoisted_17, ", "))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _createVNode(_component_Button, {
                        onClick: _ctx.toggleRequestAccess,
                        class: "mt-4 btn-sm btn-outline-primary btn-outline text-white",
                        type: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Request More ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_Button, {
                        type: "primary",
                        class: "mt-4",
                        onClick: _ctx.toggleRequestAccess
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Request Access ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
            ]),
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_Button, {
                onClick: _ctx.goToProfile,
                class: "mt-4 btn-outline-primary btn-outline text-white",
                type: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Go to Profile ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_CreateOrganizationModal, { ref: "createOrganizationModal" }, null, 512)
  ]))
}